export * from './create';
export * from './destroy';
export * from './showWithRecords';
export * from './update';
export * from './update_relations';
export * from './toggle_synced';
export * as Favorite from './favorite';

import { apiClient } from '~/api/client';

type IndexParams = {
  type: ListSTI;
};

export const index = (params: IndexParams) => apiClient.get(`/lists?type=${params.type}`);

export const dialogLists = () => apiClient.get('/lists/dialog_lists');
